import React from "react";

const Button = (props) => {

    const className = 'py-2 px-4 rounded w-full';

    let btnStyle = 'bg-[#e7bb43] text-sm font-bold text-[#111213] border border-solid border-[#e7bb43] relative ';

    const disabledStyle = 'bg-gray-400 border-gray-400 cursor-auto';

    if(props?.white)
        btnStyle = 'text-[#111213] text-sm bg-white hover:text-white hover:bg-[#111213] focus:text-[#111213] focus:bg-white font-bold border-[0.13rem] border-[#111213] rounded';

    //let btnStyle = primaryStyle;

    if(props?.disabled)
        btnStyle += disabledStyle;

    const activeProps = {
        ...props,
        ...{
            className: className + ' ' + btnStyle + ' ' + props?.className
        }
    };

    delete activeProps?.white;

    return <>
        <button type={"button"} {...activeProps}>
            {props?.children}
        </button>
    </>

};

Button.displayName = 'Button';

export default Button;